module.exports = __webpack_public_path__ + "media/images/login/icon_google-9b9160e516cad30b74375ac457f9c16d.png";